import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { Text }  from './styled';

const Header = props =>(
  <div>
    <Text bold>Payment for {props.isTopup? 'Topup Kick Credit': 'Purchased Product'}</Text>
    <Text bold>{props.title}</Text>
  </div>
)
export default Header;